import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { QuoteUpdateService } from '@services/quote/quote-update.service';
import { QtBaseData } from '@models/qt-templates.model';
import { Subject } from 'rxjs/Subject';
import { DragulaService } from 'ng2-dragula';
import { Product } from '@models/models';

@Component({
	selector: 'qt-custom-template-control',
	template: require('./qt-custom-template-control.component.html'),
	styles: [require('./qt-custom-template-control.component.scss')]
})
export class QtCustomTemplateControlComponent implements OnInit, OnDestroy {
	@Input() templateData: QtBaseData;
	@Input() disableContractButton: boolean;
	@Input() generateInvoiceDisabled: boolean;
	@Output() emitContractChange: EventEmitter<string> = new EventEmitter();
	@Output() emitContractToEdit: EventEmitter<void> = new EventEmitter();
	@Output() emitPaymentChange: EventEmitter<string> = new EventEmitter();

	dragulaPackagesOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};
	dragulaProductsOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};
	dragulaDiscountsOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};

	private unsubscribe: Subject<void> = new Subject();

	constructor(private dragulaService: DragulaService) {}

	ngOnInit(): void {
		this.setDragulaOptions();
	}

	ngOnDestroy(): void {
		this.clear();
	}

	addNewCustomTemplatePackage(): void {
		this.templateData.packages.items.push(
			QuoteUpdateService.setEmptyProduct('PACKAGE')
		);
	}

	setNewCustomTemplatePackage(data: { index: number; product: Product }): void {
		this.templateData.packages.items.forEach(
			(packageItem: Product, index: number): void => {
				if (index === data.index) {
					this.templateData.packages.items[index] = JSON.parse(
						JSON.stringify(Object.assign({}, data.product))
					);
				}
			}
		);
	}

	removeCustomTemplatePackage({ index }): void {
		this.templateData.packages.items.splice(index, 1);
	}

	addNewCustomTemplateProduct(): void {
		this.templateData.products.items.push(
			QuoteUpdateService.setEmptyProduct('ADD_ON')
		);
	}

	setNewCustomTemplateProduct(data: { index: number; product: Product }): void {
		this.templateData.products.items.forEach(
			(packageItem: Product, index: number): void => {
				if (index === data.index) {
					this.templateData.products.items[index] = JSON.parse(
						JSON.stringify(Object.assign({}, data.product))
					);
				}
			}
		);
	}

	removeCustomTemplateProduct({ index }): void {
		this.templateData.products.items.splice(index, 1);
	}

	addNewCustomTemplateDiscount(): void {
		this.templateData.discounts.items.push(
			QuoteUpdateService.setEmptyProduct('GIFT')
		);
	}

	setNewCustomTemplateDiscount(data: {
		index: number;
		product: Product;
	}): void {
		this.templateData.discounts.items.forEach(
			(packageItem: Product, index: number): void => {
				if (index === data.index) {
					this.templateData.discounts.items[index] = JSON.parse(
						JSON.stringify(Object.assign({}, data.product))
					);
				}
			}
		);
	}

	removeCustomTemplateDiscount(index: number): void {
		this.templateData.discounts.items.splice(index, 1);
	}

	onPaymentScheduleChange(templateId: string): void {
		this.templateData.paymentSchedulerTemplateId = templateId;
		switch (templateId) {
			case '-2':
				this.templateData.paymentsStrategy = 'NO_SPLIT_PAYMENTS';
				break;
			case '-3':
				this.templateData.paymentsStrategy = 'NO_DUE_DATE';
				break;
			default:
				this.templateData.paymentsStrategy = 'BY_PAYMENT_SCHEDULER';
				break;
		}
		this.emitPaymentChange.emit(templateId);
	}

	setQuestionnaire(templateId: string): void {
		this.templateData.questionnaireTemplateId = templateId;
	}

	setContract(templateId: string): void {
		this.emitContractChange.emit(templateId);
	}

	emitContractEdit(): void {
		this.emitContractToEdit.emit();
	}
	private setDragulaOptions(): void {
		this.dragulaService.setOptions('products', this.dragulaProductsOptions);
		this.dragulaService.setOptions('packages', this.dragulaPackagesOptions);
		this.dragulaService.setOptions('discounts', this.dragulaDiscountsOptions);
	}

	private clear(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.dragulaService.destroy('products');
		this.dragulaService.destroy('packages');
		this.dragulaService.destroy('discounts');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-custom-template-control/qt-custom-template-control.component.ts